import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { MyTimeRequestTypeInterface } from "my-time/components";
import { OcCalendarDay } from "oc/components";

interface MyTimeInfoDialogProps {
  open: boolean;
  handleClose: () => void;
  data: any;
  employeeName: string;
  isMobile: boolean;
}

export const MyTimeInfoDialog = ({
  open,
  handleClose,
  data,
  employeeName,
  isMobile,
}: MyTimeInfoDialogProps) => {
  const { t } = useTranslation();
  const startTime = moment(data?.startTime).format("YYYY.MM.DD HH:mm");
  const endTime = moment(data?.endTime).format("YYYY.MM.DD HH:mm");

  const timeDifference = ({
    startTime,
    endTime,
  }: {
    startTime: string;
    endTime: string;
  }) => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    let start, end;

    if (isSafari) {
      start = data?.startTime;
      end = data?.endTime;
    } else {
      start = moment(new Date(startTime));
      end = moment(new Date(endTime));
    }
    const duration = moment.duration(moment(end).diff(moment(start)));
    const minutes = duration.asMinutes();
    return minutes;
  };

  const timeConvert = (n: number) => {
    const num = n;
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    return (
      rhours.toString().padStart(2, "0") +
      ":" +
      rminutes.toString().padStart(2, "0")
    );
  };

  const minutes = timeDifference({ startTime, endTime });
  const timeSummary = timeConvert(minutes - (data?.workBreakInMinutes || 0));

  const unPaidDate = data?.dayType === "PAID_HOLLIDAY" || data?.dayType === "REST_DAY"

  return (
    <Dialog open={open} onClose={handleClose}>
      <Box padding="24px" width={isMobile ? "auto" : "547px"}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          style={{
            fontSize: "34px",
            letterSpacing: "0.25px",
            padding: "0px 16px 10px 16px",
            color: "#5E6366",
            borderBottom: "2px solid #C6CACC",
          }}
        >
          {t("MY_TIME_WORKING_SCHEDULE")}
        </Box>
        <Box paddingTop="24px">
          <Box
            style={{
              fontSize: "20px",
              lineHeight: "28px",
              letterSpacing: "0.15px",
            }}
          >
            {employeeName}
          </Box>
          <Box height="22px" />
          <Box display="flex" flexDirection="row" alignItems="center">
            <OcCalendarDay date={timeSummary} hours={true} loading={false} unPaidDate={unPaidDate} />
            <Box width="16px" />
            <Box>
              <Typography>{t("OC_PERIOD")}</Typography>
              <Box>
                {unPaidDate
                  ? `${moment(data?.date).format("YYYY.MM.DD")} - ${moment(data?.date).format("YYYY.MM.DD")}`
                  : `${startTime} - ${endTime}`}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box paddingTop="24px" paddingBottom="24px">
          <MyTimeRequestTypeInterface
            data={data}
            myTimeType={data?.myTimeType}
            timeDataTypeName={data?.timeDataTypeName}
            unPaidDate={unPaidDate}
          />
        </Box>
        <Box
          style={{
            height: "1px",
            backgroundColor: "#E3E5E5",
          }}
        />
        <Box height="24px" />
        <Box display="flex" flexDirection="row" justifyContent="flex-end">
          <Button
            id="myleave-new-request-dialog-cancel-button"
            onClick={handleClose}
            variant="text"
            color="secondary"
          >
            {t("OC_CANCEL")}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default MyTimeInfoDialog;
